import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content'];
  static values = { multiline: Boolean };

  connect() {
    this.afterMorph = () => this.schedule();
    this.element.addEventListener('turbo:morph-element', this.afterMorph);
    this.resizeObserver = new ResizeObserver(() => this.schedule());
    this.resizeObserver.observe(this.element);
    this.observer = new MutationObserver(() => this.schedule());
    this.observer.observe(this.element, { subtree: true, childList: true, characterData: true });
    document.fonts.ready.then(() => {
      if (this.element.isConnected) this.schedule();
    });
    this.schedule();
  }

  disconnect() {
    this.element.removeEventListener('turbo:morph-element', this.afterMorph);
    cancelAnimationFrame(this.frame);
    this.resizeObserver?.disconnect();
    this.observer?.disconnect();
  }

  schedule() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.fit());
  }

  fit() {
    if (!this.element.isConnected || !this.hasContentTarget || !this.element.clientHeight) return;
    const text = this.contentTarget;
    text.style.fontSize = '';
    text.style.whiteSpace = 'nowrap';
    text.style.overflowWrap = 'normal';
    const maximum = parseFloat(getComputedStyle(text).fontSize);
    const threshold = Math.min(maximum, this.element.clientHeight / 2);
    text.style.fontSize = `${threshold}px`;
    if (this.multilineValue && !this.fits(text)) {
      text.style.whiteSpace = 'normal';
      text.style.overflowWrap = 'anywhere';
      this.shrink(text, 1, threshold);
    } else {
      this.shrink(text, 1, maximum);
    }
  }

  fits(text) {
    const lineLimit = text.style.whiteSpace === 'normal' ? parseFloat(text.style.fontSize) * 2 + 1 : Infinity;
    return text.scrollWidth <= text.clientWidth && text.scrollHeight <= Math.min(this.element.clientHeight, lineLimit);
  }

  shrink(text, minimum, maximum) {
    // Binary search avoids a layout pass for every pixel of a large name.
    let low = minimum;
    let high = maximum;
    while (high - low > 0.25) {
      const size = (low + high) / 2;
      text.style.fontSize = `${size}px`;
      if (this.fits(text)) low = size;
      else high = size;
    }
    text.style.fontSize = `${low}px`;
  }
}
